module.exports = __webpack_public_path__ + "img/IMG_0300_L_BlackMatted_MockedUp.42c908e8.jpg";